import { environment as defaultEnvironment } from './environment.defaults';
export const environment = {
  ...defaultEnvironment,
  production: false,
  apiPath: 'http://dgsonline-api.kpvsolutions.com/api/v3/'
};
